import { useReveal } from "../hooks/useReveal";
import { HELLO_CLIPS } from "../data/reels";

const JETOUR_CLIPS = [
  "/assets/jetour-1.mp4",
  "/assets/jetour-2.mp4",
];

const Clip = ({ src, className = "", style = {} }) => (
  <div
    className={`relative overflow-hidden rounded-2xl bg-black shadow-[0_20px_40px_-20px_rgba(0,0,0,0.35)] ${className}`}
    style={style}
  >
    <video src={src} autoPlay muted loop playsInline className="w-full h-full object-cover" />
    <span className="absolute bottom-1.5 left-1.5 mono text-[9px] uppercase tracking-wider text-white/90 bg-[color:var(--mr-fuchsia)] px-2 py-0.5 rounded-full">
      By Modoredes
    </span>
  </div>
);

export const HelloSection = () => {
  const ref = useReveal();
  return (
    <section className="relative py-14 sm:py-20 px-5">
      <div ref={ref} className="reveal max-w-5xl md:max-w-6xl mx-auto relative">
        {/* ============ MOBILE LAYOUT (unchanged) ============ */}
        <div className="md:hidden space-y-4">
          <h2 className="display text-[42px] leading-[0.92]">
            Hello,<br />somos <span className="text-[color:var(--mr-purple)]">ModoRedes</span>
          </h2>
          <div className="grid grid-cols-2 gap-3">
            <Clip src={HELLO_CLIPS[0]} className="aspect-[3/4] col-span-1" />
            <Clip src={HELLO_CLIPS[1]} className="aspect-[3/4] col-span-1 mt-6" />
          </div>

          {/* Jetour featured */}
          <div className="pt-2">
            <span className="mono text-[10px] tracking-[0.3em] uppercase text-[color:var(--mr-fuchsia)]">
              · jetour · drive your future ·
            </span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Clip src={JETOUR_CLIPS[0]} className="aspect-[9/16]" />
            <Clip src={JETOUR_CLIPS[1]} className="aspect-[9/16] mt-6" />
          </div>

          <h2 className="display text-[36px] leading-[0.92] pl-8 pt-2">y esto es</h2>
          <div className="grid grid-cols-3 gap-3">
            <Clip src={HELLO_CLIPS[2]} className="aspect-[3/4]" />
            <Clip src={HELLO_CLIPS[3]} className="aspect-[3/4] mt-4" />
            <Clip src={HELLO_CLIPS[4]} className="aspect-[3/4]" />
          </div>
          <h2 className="display text-[42px] leading-[0.92] text-right">nuestro<br />portafolio<br />audiovisual.</h2>
        </div>

        {/* ============ DESKTOP LAYOUT (md+) — editorial flow, no overlap ============ */}
        <div className="hidden md:block">
          {/* Row 1: Big intro + 2 floating clips on the right */}
          <div className="grid grid-cols-12 gap-6 items-start">
            <div className="col-span-8">
              <h2 className="display text-[clamp(56px,7.5vw,108px)] leading-[0.88]">
                Hello,<br />
                somos<br />
                <span className="text-[color:var(--mr-purple)]">ModoRedes</span>
              </h2>
            </div>
            <div className="col-span-4 relative" style={{ minHeight: 460 }}>
              <Clip
                src={HELLO_CLIPS[0]}
                className="absolute floaty"
                style={{
                  top: 0,
                  right: 0,
                  width: "80%",
                  aspectRatio: "3/4",
                  "--r": "2.5deg",
                  transform: "rotate(2.5deg)",
                }}
              />
              <Clip
                src={HELLO_CLIPS[1]}
                className="absolute floaty"
                style={{
                  top: 220,
                  left: 0,
                  width: "70%",
                  aspectRatio: "3/4",
                  "--r": "-3deg",
                  transform: "rotate(-3deg)",
                  animationDelay: "1s",
                }}
              />
            </div>
          </div>

          {/* Row 2: "y esto es" + 3 floating clips */}
          <div className="grid grid-cols-12 gap-6 items-center mt-16 lg:mt-24">
            <div className="col-span-4">
              <h2 className="display text-[clamp(56px,7vw,96px)] leading-[0.9]">
                y esto<br />es
              </h2>
            </div>
            <div className="col-span-8 grid grid-cols-3 gap-5">
              <Clip
                src={HELLO_CLIPS[2]}
                className="aspect-[3/4] floaty"
                style={{ "--r": "3deg", transform: "rotate(3deg)" }}
              />
              <Clip
                src={HELLO_CLIPS[3]}
                className="aspect-[3/4] floaty mt-6"
                style={{ "--r": "-2deg", transform: "rotate(-2deg)", animationDelay: "0.5s" }}
              />
              <Clip
                src={HELLO_CLIPS[4]}
                className="aspect-[3/4] floaty"
                style={{ "--r": "2deg", transform: "rotate(2deg)", animationDelay: "1.2s" }}
              />
            </div>
          </div>

          {/* Row 3: Jetour featured + headline aligned right */}
          <div className="grid grid-cols-12 gap-6 items-end mt-16 lg:mt-24">
            <div className="col-span-7">
              <span className="mono text-xs tracking-[0.3em] uppercase text-[color:var(--mr-fuchsia)] block mb-5">
                · jetour · drive your future ·
              </span>
              <div className="grid grid-cols-2 gap-5">
                <Clip
                  src={JETOUR_CLIPS[0]}
                  className="aspect-[9/16] floaty"
                  style={{ "--r": "-2deg", transform: "rotate(-2deg)" }}
                />
                <Clip
                  src={JETOUR_CLIPS[1]}
                  className="aspect-[9/16] floaty mt-8"
                  style={{ "--r": "2deg", transform: "rotate(2deg)", animationDelay: "0.7s" }}
                />
              </div>
            </div>
            <div className="col-span-5">
              <h2 className="display text-[clamp(48px,6.5vw,88px)] leading-[0.9] text-right">
                nuestro<br />
                portafolio<br />
                audiovisual.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
